import React, { useState } from 'react';
import Header from './Header';
import Footer from './Footer';
import '../styles/Port.css';
import OurProductsSection from "./OurProductsSection"

import port1 from '../assets/port1.png';
import port2 from '../assets/port2.png';
import port3 from '../assets/port3.png';
import port4 from '../assets/port4.png';
import port5 from '../assets/port5.png';
import port6 from '../assets/port6.png';

import Portpdf from '../assets/dummy.pdf'
// import QuoteModal from './QuoteModal'; // Adjust path
import WhatsAppModal from './WhatsAppModal';

import portImg from '../assets/PortMain2.png';



const Port = () => {
  // const [showModal, setShowModal] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <div className="Port">
      <Header />

      {/* Hero Banner Section */}
      {/* <section className="hero-banner9">
        <div className="hero-content">
          <h1>PORT</h1>
          <div className="breadcrumb">
            <span><a href="/" style={{ color: "#ACECFC" }}>Home</a></span> ⪢ <span>Port</span>
          </div>
        </div>
      </section> */}

<section className="Port-hero-clean">
  <div className="hero-text">
    <h1>Port</h1>
    <p>
In port automation and logistics, our rugged sensors support container detection, crane positioning, and safety systems in challenging outdoor environments.
</p>
  </div>
  <br/>
  <div className="hero-image">
    <img src={portImg} alt="Port Industry" />
  </div>
</section>


<section className="port-images-grid">
  {[[port1, port2], [port3, port4], [port5, port6]].map((pair, rowIndex) => (
    <div className={`port-image-row ${rowIndex % 2 !== 0 ? 'reverse' : ''}`} key={rowIndex}>
      {pair.map((img, idx) => (
        <div className="port-image-item" key={idx}>
          <img src={img} alt={`Port ${rowIndex * 2 + idx + 1}`} />
        </div>
      ))}
    </div>
  ))}
</section>


<OurProductsSection />
      <section className="action-buttons-section">
        <a href={Portpdf} target="_blank" rel="noopener noreferrer">
          <button className="download-btn">📄 Download</button>
        </a>
          <button className="quote-btn" onClick={() => setIsModalOpen(true)}>📩 Request a Quote</button>
          {/* <QuoteModal isOpen={showModal} onClose={() => setShowModal(false)} /> */}
                {/* WhatsApp Modal */}
      <WhatsAppModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />

      </section>

      <Footer />
    </div>
  );
};
export default Port;